import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { IDataService } from '../../../../services/data/data-service.interface';

@Component({
  selector: 'gtd-business-model-format',
  template: '{{ businessModelSelect[data] }}',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessModelFormatComponent {
  @Input() data: number;
  public businessModelSelect: object;

  constructor(@Inject('IDataService') dataService: IDataService) {
    this.businessModelSelect = dataService.getData().business_model_formats;
  }
}
